import ToastAlert from "atoms/ToastAlert";
import AmplitudeHelper from "utils/analytics";
import { SentryHelper } from "utils/performance/SentryHelper";
import secureStore from "utils/secureStore";

/*
  To check for the error is type of array or not , 
  doing this to deal with multiple toast not  showing issue and displaying the first popup 
*/
export function getErrorType(err) {
  if (Array.isArray(err)) return err[0];
  return err;
}

export const showErrorToast = ({ error, toast, navigate = () => {}, resetLoginData = () => {} }) => {
  if (error && error.length > 0 && (error[0] === "GG-GEN-05" || error[0] === "GG-GEN-17")) {
    secureStore.removeItemAsync("accessToken");
    secureStore.removeItemAsync("refreshToken");
    AmplitudeHelper.clearUserProperties();
    SentryHelper.clearUser();
    resetLoginData();
    navigate("/");
  }
  toast.show({
    render: ({ id }) => (
      <ToastAlert
        toast={toast}
        id={id}
        title={`errorCodes.${getErrorType(error)}`}
        status="error"
        variant="solid"
        isClosable
      />
    ),
    placement: "top-right",
  });
};

export const showCustomToast = ({ title = "", status = "", style = {}, variant = "", toast }) => {
  return toast.show({
    render: ({ id }) => (
      <ToastAlert toast={toast} id={id} title={title} status={status} isClosable variant={variant} style={style} />
    ),
    placement: "top-right",
  });
};

export function checkForActiveHandler(formData, updatedData) {
  const newData = { ...updatedData };
  if (formData?.status === "Aktif" || formData?.status === "active") {
    newData.suspendedReason = undefined;
    newData.suspensionCategory = undefined;
  }
  return newData;
}
